import { render, staticRenderFns } from "./CreateTaskPopUp.vue?vue&type=template&id=9c3fa734&scoped=true&"
import script from "./CreateTaskPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateTaskPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3fa734",
  null
  
)

export default component.exports